export default __webpack_public_path__ + "resmi_kazandi.png";